import {LocaleData} from "i18n-iso-countries"
import {Locale as MomentLocale} from "moment"
import {Locale as AntdLocale} from "antd/lib/locale-provider"

type I18nImports = {
    countries: () => Promise<LocaleData>
    moment: () => Promise<MomentLocale | null>
    antd: () => Promise<{default: AntdLocale}>
}

export const i18nImports: Record<string, I18nImports> = {
    en: {
        countries: () => import("i18n-iso-countries/langs/en.json"),
        moment: () => Promise.resolve(null), // 'en' is the default locale in moment.js and does not require explicit import
        antd: () => import("antd/lib/locale/en_US"),
    },
    ru: {
        countries: () => import("i18n-iso-countries/langs/ru.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/ru"),
        antd: () => import("antd/lib/locale/ru_RU"),
    },
    es: {
        countries: () => import("i18n-iso-countries/langs/es.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/es"),
        antd: () => import("antd/lib/locale/es_ES"),
    },
    ca: {
        countries: () => import("i18n-iso-countries/langs/ca.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/ca"),
        antd: () => import("antd/lib/locale/ca_ES"),
    },
    gl: {
        countries: () => import("i18n-iso-countries/langs/gl.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/gl"),
        antd: () => import("antd/lib/locale/gl_ES"),
    },
    eu: {
        countries: () => import("i18n-iso-countries/langs/eu.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/eu"),
        antd: () => import("antd/lib/locale/es_ES"),
    },
    fr: {
        countries: () => import("i18n-iso-countries/langs/fr.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/fr"),
        antd: () => import("antd/lib/locale/fr_FR"),
    },
    it: {
        countries: () => import("i18n-iso-countries/langs/it.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/it"),
        antd: () => import("antd/lib/locale/it_IT"),
    },
    pl: {
        countries: () => import("i18n-iso-countries/langs/pl.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/pl"),
        antd: () => import("antd/lib/locale/pl_PL"),
    },
    da: {
        countries: () => import("i18n-iso-countries/langs/da.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/da"),
        antd: () => import("antd/lib/locale/da_DK"),
    },
    fi: {
        countries: () => import("i18n-iso-countries/langs/fi.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/fi"),
        antd: () => import("antd/lib/locale/fi_FI"),
    },
    de: {
        countries: () => import("i18n-iso-countries/langs/de.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/de"),
        antd: () => import("antd/lib/locale/de_DE"),
    },
    nl: {
        countries: () => import("i18n-iso-countries/langs/nl.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/nl"),
        antd: () => import("antd/lib/locale/nl_NL"),
    },
    no: {
        countries: () => import("i18n-iso-countries/langs/no.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/nb"),
        antd: () => import("antd/lib/locale/nb_NO"),
    },
    sv: {
        countries: () => import("i18n-iso-countries/langs/sv.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/sv"),
        antd: () => import("antd/lib/locale/sv_SE"),
    },
    kk: {
        countries: () => import("i18n-iso-countries/langs/kk.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/kk"),
        antd: () => import("antd/lib/locale/kk_KZ"),
    },
    lv: {
        countries: () => import("i18n-iso-countries/langs/lv.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/lv"),
        antd: () => import("antd/lib/locale/lv_LV"),
    },
    lt: {
        countries: () => import("i18n-iso-countries/langs/lt.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/lt"),
        antd: () => import("antd/lib/locale/lt_LT"),
    },
    sk: {
        countries: () => import("i18n-iso-countries/langs/sk.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/sk"),
        antd: () => import("antd/lib/locale/sk_SK"),
    },
    sl: {
        countries: () => import("i18n-iso-countries/langs/sl.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/sl"),
        antd: () => import("antd/lib/locale/sl_SI"),
    },
    et: {
        countries: () => import("i18n-iso-countries/langs/et.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/et"),
        antd: () => import("antd/lib/locale/et_EE"),
    },
    cs: {
        countries: () => import("i18n-iso-countries/langs/cs.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/cs"),
        antd: () => import("antd/lib/locale/cs_CZ"),
    },
    hu: {
        countries: () => import("i18n-iso-countries/langs/hu.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/hu"),
        antd: () => import("antd/lib/locale/hu_HU"),
    },
    bg: {
        countries: () => import("i18n-iso-countries/langs/bg.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/bg"),
        antd: () => import("antd/lib/locale/bg_BG"),
    },
    hr: {
        countries: () => import("i18n-iso-countries/langs/hr.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/hr"),
        antd: () => import("antd/lib/locale/hr_HR"),
    },
    uk: {
        countries: () => import("i18n-iso-countries/langs/uk.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/uk"),
        antd: () => import("antd/lib/locale/uk_UA"),
    },
    ro: {
        countries: () => import("i18n-iso-countries/langs/ro.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/ro"),
        antd: () => import("antd/lib/locale/ro_RO"),
    },
    el: {
        countries: () => import("i18n-iso-countries/langs/el.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/el"),
        antd: () => import("antd/lib/locale/el_GR"),
    },
    sq: {
        countries: () => import("i18n-iso-countries/langs/sq.json"),
        moment: () => Promise.resolve(null), // 'en' is the default locale in moment.js and does not require explicit import
        antd: () => import("antd/lib/locale/en_US"),
    },
    mk: {
        countries: () => import("i18n-iso-countries/langs/mk.json"),
        // @ts-expect-error https://github.com/moment/moment/issues/5202 Workarounds don't work
        moment: () => import("moment/locale/mk"),
        antd: () => import("antd/lib/locale/mk_MK"),
    },
}
